/**
 * WebSocket host URL, the MAUI Container should run the socket server
 */

// export const DevWebSocketServer = "ws://192.168.100.121:2999";

// export const DevWebSocketServer = "ws://localhost:2998";

export const DevWebSocketServer = "ws://localhost:3508";
